export const getUrlQSParam = (fieldName: string) => {
  if (typeof window === 'undefined') {
    return '';
  }
  const urlSearchParams = new URLSearchParams(window.location.search);
  const fieldValue = urlSearchParams.get(fieldName);
  return (fieldValue === null ? '' : fieldValue);
};
